<template>
  <tr>
    <th>
      예약 시간
      <span class="required">*</span>
    </th>
    <td>
      <select v-model="hours">
        <option value="00">00시</option>
        <option value="01">01시</option>
        <option value="02">02시</option>
        <option value="03">03시</option>
        <option value="04">04시</option>
        <option value="05">05시</option>
        <option value="06">06시</option>
        <option value="07">07시</option>
        <option value="08">08시</option>
        <option value="09">09시</option>
        <option value="10">10시</option>
        <option value="11">11시</option>
        <option value="12">12시</option>
        <option value="13">13시</option>
        <option value="14">14시</option>
        <option value="15">15시</option>
        <option value="16">16시</option>
        <option value="17">17시</option>
        <option value="18">18시</option>
        <option value="19">19시</option>
        <option value="20">20시</option>
        <option value="21">21시</option>
        <option value="22">22시</option>
        <option value="23">23시</option>
      </select>
      <select v-model="minutes">
        <option value="00">00분</option>
        <option value="10">10분</option>
        <option value="20">20분</option>
        <option value="30">30분</option>
        <option value="40">40분</option>
        <option value="50">50분</option>
      </select>
      <p v-if="messageType === 'register'" class="caution">
        <span class="ico">*</span> 다른 소식의 예약 시간과 중복되지 않도록 설정해 주세요. 중복일 경우 1개만 전달됩니다.
      </p>
    </td>
  </tr>
</template>

<script>
export default {
  props: {
    reserveTime: {
      type: String,
      default: '09:00:00',
    },
    messageType: {
      type: String,
      default: 'register',
    },
  },
  data() {
    const propsTimes = this.reserveTime.split(':');
    return {
      hours: propsTimes[0],
      minutes: propsTimes[1],
    };
  },
  computed: {
    result() {
      return `${this.hours}:${this.minutes}:00`;
    },
  },
  watch: {
    hours() {
      this.$emit('update:reserveTime', this.result);
    },
    minutes() {
      this.$emit('update:reserveTime', this.result);
    },
  },
};
</script>

<style></style>
